module.exports = __webpack_public_path__ + "img/business_college_headder.989c0cc1.jpg";